import { API_BASE_URL } from '../config/constants';

export type OcrExtractResult = {
  companyName?: string;
  taxNumber?: string;
  identityNum?: string;
  phone?: string;
  address?: string;
  email?: string;
  taxOffice?: string;
  region?: string;
  regionCode?: string;
  city?: string;
  district?: string;
  rawText?: string;
};

export async function extractCustomerFromImage(file: File): Promise<OcrExtractResult> {
  const formData = new FormData();
  formData.append('file', file);

  const resp = await fetch(`${API_BASE_URL}/api/v1/ai/extract`, {
    method: 'POST',
    body: formData,
  });
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || 'AI çıkarım servisi hata döndürdü');
  }
  return resp.json();
}
